import { render, staticRenderFns } from "./CrewBasicInfo.vue?vue&type=template&id=6aa03764&scoped=true"
import script from "./CrewBasicInfo.vue?vue&type=script&lang=js"
export * from "./CrewBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./CrewBasicInfo.vue?vue&type=style&index=0&id=6aa03764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa03764",
  null
  
)

export default component.exports